import ClinicDepartmentService from "../../../../../../services/ClinicDepartmentService";
import DropDownService from "../../../../../../services/DropDownService";
import ProviderService from "../../../../../../services/ProviderService";
import {
  fetchTimeInterval,
  getCurrentTime,
  isSet,
  optionsToKeyValuePairs,
} from "../../../../../../utils/commonUtils";
export const fetchProviderList = async (val, props, callback = () => {}) => {
  const { employeeDetails } = props;
  let optionArr = [];
  try {
    const data = await ProviderService.getProviderByClinicId(
      employeeDetails.clinic_id,
      { search: val }
    );
    isSet(data, []).map((item, itemIndex) => {
      optionArr.push({
        label: isSet(item.first_name, "") + " " + isSet(item.last_name, ""),
        value: item.provider_id,
        autoPopulateFields: {
          medical_examiners_license_certificate_or_registration_number:
            item.license,
          national_registry_number: item.dol_registry_id,
          medical_examiners_certificate_expiration_date:
            item.dol_registry_expires,
        },
        data: item,
        index: itemIndex,
      });
    });
    callback(optionArr);
  } catch (e) {}
  return optionArr;
};
export const XrayPanel = (props) => {
  console.log('XrayPanel props',props);
  const charts = [
    {
      type: "Grid",
      col: "col-md-3",
      data: [
        {
          type: "PatientDetails",
          employeeDetails: props.employeeDetails,
          visitDetails: props.visitDetails,
        },
        {
          type: "CompanyDetails",
          companyDetails: props.companyDetails,
        },
      ],
    },
    {
      type: "Tab",
      col: "col-md-9",
      data: [
        {
          id: "lab_order",
          label: "Radiology Order",
          data: [
            {
              label: "Radiology Order",
              fields: [
                {
                  label: "Patient ID",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "patient_ref_id",
                  value: props.companyDetails.patient_id||"",
                  id: "patient_ref_id",
                  type: "NonEdit",
                },
                {
                  type: "SelectList",
                  options: [
                    { label: "-Select-", value: "" },
                    { label: "X-ray – Chest", value: "Xray_Chest" },
                    { label: "X-ray – Abdomen", value: "Xray_Abdomen" },
                    {
                      label: "X-ray – Spine (Cervical / Thoracic / Lumbar)",
                      value: "Xray_Spine",
                    },
                    { label: "X-ray – Pelvis", value: "Xray_Pelvis" },
                    {
                      label: "X-ray – Extremity (Arm / Leg / Wrist / Ankle)",
                      value: "Xray_Extremity",
                    },
                    { label: "CT scan – Head", value: "CT_Head" },
                    { label: "CT scan – Chest", value: "CT_Chest" },
                    {
                      label: "CT scan – Abdomen / Pelvis",
                      value: "CT_Abdomen_Pelvis",
                    },
                    { label: "MRI – Brain", value: "MRI_Brain" },
                    { label: "MRI – Spine", value: "MRI_Spine" },
                    {
                      label: "MRI – Joint (Knee / Shoulder / Hip)",
                      value: "MRI_Joint",
                    },
                    {
                      label: "Ultrasound – Abdomen",
                      value: "Ultrasound_Abdomen",
                    },
                    {
                      label: "Ultrasound – Pelvis",
                      value: "Ultrasound_Pelvis",
                    },
                    {
                      label: "Ultrasound – Thyroid",
                      value: "Ultrasound_Thyroid",
                    },
                    {
                      label: "Ultrasound – Doppler (Venous / Arterial)",
                      value: "Ultrasound_Doppler",
                    },
                    {
                      label: "Fluoroscopy – Barium Swallow",
                      value: "Fluoroscopy_Barium_Swallow",
                    },
                    {
                      label: "Mammography – Screening",
                      value: "Mammography_Screening",
                    },
                    {
                      label: "Mammography – Diagnostic",
                      value: "Mammography_Diagnostic",
                    },
                    {
                      label: "DEXA Scan – Bone Density",
                      value: "DEXA_Bone_Density",
                    },
                    {
                      label: "Nuclear Medicine – Whole Body / Organ Specific",
                      value: "NuclearMedicine",
                    },
                  ],

                  label: "Radiology Order",
                  className: "form-control form-control-solid",
                  name: "radiology_order",
                },
                {
                  type: "SelectSearchList",
                  options: [
                    {
                      label: "AP (anteroposterior)",
                      value: "AP (anteroposterior)",
                    },
                    { label: "Lateral", value: "Lateral" },
                    { label: "Oblique", value: "Oblique" },
                    { label: "Stress views", value: "Stress views" },
                    {
                      label: "Special (Scaphoid, Sunrise, etc.)",
                      value: "Special (Scaphoid, Sunrise, etc.)",
                    },
                  ],
                  label: "Views Obtained",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "views_obtained",
                  id: "views_obtained",
                  isMulti: true,
                },
                {
                  type: "SelectList",
                  options: [
                    { label: "-Select-", value: "" },
                    { label: "PCP (Primary Care Physician)", value: "PCP" },
                    {
                      label: "Specialist - Orthopedics",
                      value: "Specialist_Ortho",
                    },
                    {
                      label: "Specialist - Neurology",
                      value: "Specialist_Neuro",
                    },
                    {
                      label: "Emergency Department (ED) Physician",
                      value: "ED_Physician",
                    },
                    { label: "Internal Medicine", value: "Internal_Med" },
                    { label: "Chiropractor", value: "Chiropractor" },
                    {
                      label: "Non-Physician Provider (NP/PA)",
                      value: "Non_Physician_Provider",
                    },
                  ],
                  label: "Referral Choice",
                  className: "form-control form-control-solid",
                  name: "referral_choice",
                  id: "referral_choice",
                },
                {
                  label: "Reason for lab (ICD-10)",
                  name: "reason_for_lab",
                  id: "reason_for_lab",
                  className: "form-group sh_emrtableformgroup  mb-0",
                  type: "SelectSearchFields",
                  displayValue: props.formData.reason_for_lab_label||"",
                  isAsync: true,
                  isCacheNeeded: false,
                  loadCallBack:(val, callback) =>props.fetchIcd10List(val, callback),
                  col: "col-6",
                  options: props.reasonForLabs,
                },
                {
                  type: "SelectList",
                  options: [
                    { label: "-Select-", value: "" },
                    { label: "X-ray", value: "X-ray" },
                    { label: "CT scan", value: "CT_scan" },
                    { label: "MRI", value: "MRI" },
                    { label: "Ultrasound", value: "Ultrasound" },
                    { label: "Fluoroscopy", value: "Fluoroscopy" },
                  ],
                  label: "Imaging Modality",
                  placeholder: "Single-select dropdown",
                  className: "form-control form-control-solid",
                  name: "imaging_modality",
                  isMulti: false,
                },
                {
                  type: "Date",
                  label: "Order Date",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "order_date",
                  required: true,
                },
                {
                  type: "SelectSearchList",
                  label: "Order Time",
                  placeholder: "Order Time",
                  isAsync: true,
                  options: [
                    { label: getCurrentTime(), value: getCurrentTime() },
                  ],
                  loadCallBack: (val, callback) =>
                    fetchTimeInterval(val, callback),
                  className: "form-control form-control-solid",
                  name: "order_time",
                  required: true,
                },
              ],
            },
            {
              label: `Radiology Results - ${props.activityName}`,
              fields: [
                {
                  type: "Date",
                  label: "Result Date",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "result_date",
                  required: true,
                },
                {
                  type: "SelectSearchList",
                  label: "Result Time",
                  isAsync: true,
                  options: [
                    { label: getCurrentTime(), value: getCurrentTime() },
                  ],
                  loadCallBack: (val, callback) =>
                    fetchTimeInterval(val, callback),
                  className: "form-control form-control-solid",
                  name: "result_time",
                  required: true,
                },
                {
                  type: "SelectList",
                  options: [
                    { label: "-Select-", value: "" },
                    {
                      label: "Normal study + no acute findings",
                      value: "Normal_No_Acute",
                    },
                    {
                      label: "Consistent with acute fracture",
                      value: "Consistent_Acute_Fracture",
                    },
                    {
                      label:
                        "Suspected but not confirmed fracture - clinical certainty is low",
                      value: "Suspected_Fracture_Low_Certainty",
                    },
                    {
                      label: "Degenerative changes only",
                      value: "Degenerative_Changes_Only",
                    },
                    {
                      label: "Non-orthopedic findings (e.g., pneumonia)",
                      value: "Non_Orthopedic_Findings",
                    },
                    {
                      label:
                        "Awaiting radiology read - preliminary interpretation is needed",
                      value: "Awaiting_Radiology_Read",
                    },
                  ],
                  label: "Provider Impression / Assessment",
                  className: "form-control form-control-solid",
                  name: "provider_impression_assessment",
                },
                {
                  type: "SelectList",
                  options: [
                    { label: "-Select-", value: "" },
                    {
                      label: "Normal / No acute abnormality",
                      value: "Normal_No_Abnormality",
                    },
                    {
                      label: "Fracture - undisplaced",
                      value: "Fracture_Undisplaced",
                    },
                    {
                      label: "Fracture - displaced",
                      value: "Fracture_Displaced",
                    },
                    { label: "Dislocation", value: "Dislocation" },
                    { label: "Effusion", value: "Effusion" },
                    {
                      label: "Degenerative changes / arthritis",
                      value: "Degenerative_Changes_Arthritis",
                    },
                    {
                      label: "Foreign body present",
                      value: "Foreign_Body_Present",
                    },
                    { label: "Other (specify)", value: "Other_Specify" },
                  ],
                  label: "Radiology Findings",
                  placeholder:
                    "Single-select dropdown with optional free-text override",
                  className: "form-control form-control-solid",
                  name: "radiology_findings",
                  isMulti: false,
                },
                {
                  type: "SelectList",
                  options: [
                    { label: "-Select-", value: "" },
                    { label: "Splint applied", value: "Splint_Applied" },
                    { label: "Sling provided", value: "Sling_Provided" },
                    { label: "Crutches provided", value: "Crutches_Provided" },
                    {
                      label: "Referred to Orthopedics",
                      value: "Referred_To_Orthopedics",
                    },
                    {
                      label: "Referred to Occupational Health",
                      value: "Referred_To_Occupational_Health",
                    },
                    {
                      label: "Follow-up imaging ordered",
                      value: "Followup_Imaging_Ordered",
                    },
                    {
                      label: "Return to work full duty",
                      value: "Return_To_Work_Full_Duty",
                    },
                    {
                      label: "Return to work modified duty",
                      value: "Return_To_Work_Modified_Duty",
                    },
                    {
                      label: "Out of work – recheck in ___ days",
                      value: "Out_Of_Work_Recheck_In_Days",
                    },
                  ],
                  label: "Plan / Next Steps",
                  className: "form-control form-control-solid",
                  name: "plan_next_steps",
                },
              ],
            },
            {
              label: "Activity Details - " + props.activityName,
              fields: [
                {
                  label: "Xray",
                  col: "col-6",
                  type: "SelectList",
                  id: "xray",
                  name: "xray",
                  options: optionsToKeyValuePairs([
                    "Abnormal",
                    "Normal",
                    "Incidental Finding - Referred to PCP",
                    "Abnormal - Referred to PCP",
                  ]),
                },
                // {
                //   label: "Suggested Result",
                //   type: "TextInput",
                //   disabled: true,
                //   options: [
                //     { label: "Not Started", value: "Not Started" },
                //     { label: "Pending", value: "Pending" },
                //     { label: "Failed", value: "Failed" },
                //     { label: "Passed", value: "Passed" },
                //   ],
                //   name: "suggested_status",
                // },
                {
                  label: "Notes",
                  col: "col-6",
                  type: "TextArea",
                  name: "notes",
                },

                // {
                //   label: "Final Determination",
                //   type: "SelectList",
                //   options: [
                //     { label: "Not Started", value: "Not Started" },
                //     { label: "Pending", value: "Pending" },
                //     { label: "Failed", value: "Failed" },
                //     { label: "Passed", value: "Passed" },
                //   ],
                //   name: "status",
                // },
              ],
            },
            {
              label: "Provider Approval",
              col: "col-6",
              fields: [
                {
                  label: "Exam Date",
                  type: "Date",
                  name: "exam_date",
                  id: "exam_date",
                  col: "col-6",
                },
                {
                  label: "Provider Notes",
                  col: "col-6 align-self-start",
                  type: "TextArea",
                  name: "provider_notes",
                },
                // {
                //   type: "ProviderSignOff",
                //   col: "col-12",
                //   fields: [
                //     { label: "Enter PIN", name: "provider_pin", col: "col-12" },
                //     { label: "Our Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                //   ],
                // },
                // {
                //   label: "Status",
                //   type: "SelectList",
                //   // options:[],
                //   options: isSet(props.lookupsOptions["chartResult"], []),
                //   name: "status",
                //   id: "status",
                // },
              ],
            },
            {
              label: "Review / Completion",
              // labelStyle: "fw-semibold",
              fields: [
                  {
                      type: "ProviderSignOff",
                      col: "col-12",
                      fields: [
                          { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                          { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                          { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                          // { label : "Suggested Result",disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                          { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started', 'Normal', 'Abnormal']),statusBasedColor: true },
                          { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started', 'Ordered', 'Ready for Review', 'Completed', 'Cancelled']),statusBasedColor: true },
                      ],
                  },
              ],
          }
          ],
        },
        {
          id: "Images",
          label: "Images",
          data: []
        }
      ],
    },
  ];
  const defaultValue = {
    status: "Not Started",
    suggested_status: "Not Started",
    activity_status: "Not Started",
    // reason:'Pre-employment'
  };
  const buttons = {};
  const headers = [{
    type: 'Tab',
    data: [
      {
        label: 'Radiology Order',
        id: 'lab_order'
      },
      {
        label: 'Images',
        id: 'Images'
      }
    ]
  }];
  return {
    charts,
    defaultValue,
    buttons,
    headers,
    computationFunction: (formData, key) => computationRules(formData, key),
  };
};

const computationRules = (formData, key) => {
  // const xray = isSet(formData.xray, "");
  // let status = "Not Started";
  // if (xray === "Abnormal") {
  //   status = "Failed";
  // } else if (isSet(xray !== "")) {
  //   status = "Passed";
  // }
  // return key === "status" ? {} : { status: status, suggested_status: status };
};
